module.exports = __webpack_public_path__ + "img/code-branch.d17a5b07.svg";